import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { allFilterPages } from '@features/filter/static/filterUtil';
import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const Season = ({ filterPageName, isDependentFilter, type = 'SEASON' }) => {
	const [options, setOptions] = useState([]);
	const [allOptionList, setAllOptionList] = useState([]);
	const storeData = []; //TODO ( fetch store data for corresponding field)
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);

	useEffect(() => {
		if (!isDependentFilter) {
			setOptions(allOptionList);
		}
	}, [storeData]);

	useEffect(() => {
		if (allOptionList?.length === 0 && !isDependentFilter) {
			//TODO ( dispatch store data for corresponding field)
		} else {
			onSetFieldData();
		}
	}, [dependentFilterList, type]);

	const filterData = {
		[allFilterPages.COLLECTION_LIST]: {
			SEASON: dependentFilterList?.seasonList
		},
		[allFilterPages.PRODUCT_LIST]: {
			SEASON: dependentFilterList?.seasonList
		},
		[allFilterPages.ARTWORK_LIST]: {
			SEASON: dependentFilterList?.seasonTagList,
			THEME: dependentFilterList?.artworkThemeTagList
		}
	};

	const onSetFieldData = () => {
		let responseData = isDependentFilter
			? filterData[filterPageName]?.[type]?.map((item) => ({
					...item,
					id: item.constant || item.id,
					name: item.name,
					count: item.count
				}))
			: storeData?.map((item) => {
					return { id: item.constant || item.id, name: item.name };
				});
		setAllOptionList(responseData);
		setOptions(responseData);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allOptionList.filter((item) => item.name.toLowerCase().includes(e.target.value.toLowerCase()))
			: allOptionList;
		setOptions(searchResult);
	};

	return (
		<>
			<FilterName type={type} />
			<Checkbox type={type} data={options} handleSearch={handleSearch} key={type} />
		</>
	);
};

export default Season;
